export const ENTRYPOINT = process.env.API_ENTRYPOINT;
export const API_URL = process.env.API_URL;
export const JSON2EXCEL_URL = process.env.APP_JSON2EXCEL_URL;
export const CLIENT_ID = process.env.OIDC_CLIENT_ID;
export const GUEST_CLIENT_ID = process.env.OIDC_GUEST_CLIENT_ID;

export const OIDC_REDIRECT_URL = process.env.OIDC_REDIRECT_URL;
export const OIDC_REDIRECT_PATH = process.env.OIDC_REDIRECT_PATH;
export const OIDC_AUTHORITY = process.env.OIDC_AUTHORITY;
export const ROUTER_BASE = process.env.ROUTER_BASE;
export const ADMIN_URL = process.env.ADMIN_URL;
export const IVS_URL = process.env.IVS_URL;
export const MYUSJ_FRONTEND_URL = process.env.MYUSJ_FRONTEND_URL;
export const MYUSJ_BACKEND_URL = process.env.MYUSJ_BACKEND_URL;

export const UNLEASH_PROXY_URL = process.env.UNLEASH_PROXY_URL;
export const UNLEASH_PROXY_CLIENT_KEY = process.env.UNLEASH_PROXY_CLIENT_KEY;
export const UNLEASH_APP_NAME = process.env.UNLEASH_APP_NAME;

export const SENTRY_DSN = process.env.SENTRY_DSN;
export const SENTRY_ENV = process.env.SENTRY_ENV;
export const SENTRY_SAMPLE_RATE = process.env.SENTRY_SAMPLE_RATE;

export const VERSION = process.env.VERSION;

export const MYUSJ_URL = process.env.MYUSJ_URL;
export const SURVEY_URL = process.env.SURVEY_URL;

export const MERCURE_URL = process.env.MERCURE_URL;

export const MODE = process.env.MODE;
export const DEV = process.env.DEV;
export const TEST = process.env.TEST;
export const PROD = process.env.PROD;

console.debug('ENTRYPOINT', ENTRYPOINT);
console.debug('API_URL', API_URL);
console.debug('JSON2EXCEL_URL', JSON2EXCEL_URL);
console.debug('CLIENT_ID', CLIENT_ID);
console.debug('GUEST_CLIENT_ID', GUEST_CLIENT_ID);
console.debug('OIDC_REDIRECT_URL', OIDC_REDIRECT_URL);
console.debug('OIDC_REDIRECT_PATH', OIDC_REDIRECT_PATH);
console.debug('OIDC_AUTHORITY', OIDC_AUTHORITY);
console.debug('ROUTER_BASE', ROUTER_BASE);
